import { readFile } from 'node:fs/promises';
import { createHash } from 'node:crypto';
import { join } from 'node:path';
import JSON5 from 'json5';
import type { DriftCheckOptions, LiveState } from './types.js';

async function hashFile(filePath: string): Promise<string | null> {
  try {
    const content = await readFile(filePath);
    return createHash('sha256').update(content).digest('hex');
  } catch {
    return null;
  }
}

async function readJsonFile(filePath: string): Promise<Record<string, unknown> | null> {
  try {
    const content = await readFile(filePath, 'utf-8');
    return JSON5.parse(content) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export async function readLiveState(options: DriftCheckOptions): Promise<LiveState> {
  const trackedFiles = options.trackedFiles ?? ['CLAUDE.md', 'CHARTER.md', 'TOOLS.md'];

  // Config file is the first tracked file (framework-specific config)
  // CHARTER.md and TOOLS.md are identified by name within the tracked list
  const charterFile = trackedFiles.find((f) => f.includes('CHARTER')) ?? 'CHARTER.md';
  const toolsFile = trackedFiles.find((f) => f.includes('TOOLS')) ?? 'TOOLS.md';

  const [frameworkConfig, charterHash, toolsHash] = await Promise.all([
    readJsonFile(options.configPath),
    hashFile(join(options.teamDir, charterFile)),
    hashFile(join(options.teamDir, toolsFile)),
  ]);

  return {
    frameworkConfig,
    charterHash,
    toolsHash,
    configPath: options.configPath,
  };
}
